import React from 'react';

interface FooterProps {
  darkMode: boolean;
}

const Footer: React.FC<FooterProps> = ({ darkMode }) => {
  const theme = {
    text: darkMode ? 'text-gray-500' : 'text-gray-400',
    link: darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700',
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    window.history.pushState(null, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <footer className="flex-shrink-0 pt-8 pb-4 flex flex-col items-center gap-4 mt-12">
      <div className={`text-sm flex flex-col items-center gap-4 ${theme.text}`}>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a href="https://echologai.com/" target="_blank" rel="noopener noreferrer" className={`hover:underline font-medium ${theme.link}`}>
            Echolog AI
          </a>
          <span className="hidden sm:inline">•</span>
          <a href="/about" onClick={(e) => handleLinkClick(e, '/about')} className={`hover:underline ${theme.link}`}>About</a>
          <span className="hidden sm:inline">•</span>
          <a href="https://echologai.com/blog/" target="_blank" rel="noopener noreferrer" className={`hover:underline ${theme.link}`}>
            Blog
          </a>
          <span className="hidden sm:inline">•</span>
          <a href="/privacy" onClick={(e) => handleLinkClick(e, '/privacy')} className={`hover:underline ${theme.link}`}>Privacy Policy</a>
          <span className="hidden sm:inline">•</span>
          <a href="/terms" onClick={(e) => handleLinkClick(e, '/terms')} className={`hover:underline ${theme.link}`}>Terms of Service</a>
          <span className="hidden sm:inline">•</span>
          <a href="mailto:echolog07@gmail.com" className={`hover:underline ${theme.link}`}>Contact</a>
        </div>
        <span className="text-xs">© 2025 Echolog AI Team. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;

